/**
 * Check if a value is plain object, with generic type support
 */
export const isPlainObject = (val) => Object.prototype.toString.call(val) === '[object Object]';
